<template>
  <v-card>
    <v-card-title>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table
      :search="search"
      :headers="headers"
      :items="items"
      :items-per-page="-1"
      :loading="loading"
      class="elevation-1"
      hide-default-footer
      :mobile-breakpoint='0'
      @click:row="itemClicked"
    >
      <template v-slot:item.image="{ item }">
        <v-img max-height="28" max-width="28" :src="item.icon"></v-img>
      </template>
      <template v-if="coin" v-slot:body.prepend="{ headers }">
        <tr>
          <td class="text-start" :colspan="headers.length / 3">
            <v-img max-height="15" max-width="15" src="https://wiki.guildwars2.com/images/d/d1/Gold_coin.png"></v-img>
          </td>
          <td class="text-start" :colspan="headers.length / 3">
            coin
          </td>
          <td class="text-start" :colspan="headers.length/ 3">
            {{coin}}
          </td>
        </tr>
      </template>
      <template v-slot:no-data>
        {{ noData }}
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
export default {
  props: ['items', 'headers', 'noData', 'coin', 'loading'],
  data() {
    return {
      search: '',
    };
  },
  methods: {
    itemClicked({ id }) {
      if (!id) return;
      window.open(`https://www.gw2bltc.com/en/item/${id}`);
    },
  },
};
</script>
